<div class="form-page">
  @if (info.isLoading()) {
    <kendo-loader type="infinite-spinner" themeColor="primary" size="medium" />
  } @else if (info.error() || !info.value()) {
    <span class="result-error">
      This password recovery link may be expired, already used, invalid or a
      temporary error happened.
    </span>
  } @else if (submitResult() === passwordChangeResult.Success) {
    <span class="result-success">
      {{
        isInitialSet()
          ? 'Password set successfully!'
          : 'Password reset successfully!'
      }}
    </span>
    @if (willRedirectBack()) {
      <p>You will be redirected back shortly.</p>
    }
  } @else if (info.value(); as value) {
    <form class="form-card" (submit)="submit($event)">
      <h1>{{ isInitialSet() ? 'Set your password' : 'Password reset' }}</h1>
      <p>for {{ value.targetUserEmail }}</p>

      <label for="newPassword">New password</label>
      <input
        type="password"
        id="newPassword"
        [formField]="passwordResetForm.newPassword"
        class="k-input k-input-md form-input"
      />

      <label for="verifyPassword">New password again</label>
      <input
        type="password"
        id="verifyPassword"
        [formField]="passwordResetForm.verifyPassword"
        class="k-input k-input-md form-input"
      />

      @if (
        passwordResetForm.newPassword().touched() &&
        passwordResetForm.verifyPassword().touched() &&
        !passwordResetForm().valid()
      ) {
        @for (error of passwordResetForm().errors(); track error) {
          <span class="error-sub">{{ error.message }}</span>
        }
      }

      <button
        kendoButton
        themeColor="primary"
        type="submit"
        [disabled]="!passwordResetForm().valid() || isLoading()"
        class="form-button"
      >
        {{ isInitialSet() ? 'Set password' : 'Reset password' }}
      </button>

      @switch (submitResult()) {
        @case ('internal-error') {
          <span class="error-sub">An unknown error happened</span>
        }
        @case (passwordChangeResult.WeakPassword) {
          <span class="error-sub">
            The new password is too weak. At least 1 lowercase, 1 uppercase and
            1 numeric or special character is required.
          </span>
        }
      }
    </form>
  }
</div>
